import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuth: false,
};

export const auth = createSlice({
  name: "favorite",
  initialState,
  reducers: {
    loginReduxState: (state) => {
      state.isAuth = true;
    },
    logoutReduxState: (state) => {
      state.isAuth = false;
    },
  },
});

export const { loginReduxState, logoutReduxState } = auth.actions;

export default auth.reducer;
